import React, { createContext, useState, useContext } from "react";

const ParallelPersonaContext = createContext();

export const useParallelPersona = () => useContext(ParallelPersonaContext);

export const ParallelPersonaProvider = ({ children }) => {
  const [dataset, setDataset] = useState("SurveyData.xlsx");
  const [location, setLocation] = useState([]);
  const [ethnicity, setEthnicity] = useState([]);
  const [topics, setTopics] = useState([]);
  const [personas, setPersonas] = useState([]);
  const [personaData, setPersonaData] = useState({});
  const [parallel, setParallel] = useState(false);

  return (
    <ParallelPersonaContext.Provider
      value={{
        dataset,
        setDataset,
        location,
        setLocation,
        ethnicity,
        setEthnicity,
        topics,
        setTopics,
        personas,
        setPersonas,
        personaData,
        setPersonaData,
        parallel,
        setParallel,
      }}
    >
      {children}
    </ParallelPersonaContext.Provider>
  );
};
